<template>
  <div id="Home">
    <div id="description">
      <p>Locations saisonnières d'appartements à Cannes</p>
      <p>Seasonal rentals in Cannes</p>
    </div>
    <h2>Nos appartements</h2>
    <Apartment title='Le Studio'
               description='Studio tout confort, entièrement refait à neuf et décoré avec soin. Vous accéderez gratuitement à la piscine et au bain de soleil de la résidence. Il peut accueillir deux personnes avec un canapé très confortable rapido avec véritable matelas.'
               :files='["/static/appartment1/1.jpg","/static/appartment1/2.JPG","/static/appartment1/3.JPG","/static/appartment1/4.JPG","/static/appartment1/5.JPG","/static/appartment1/6.JPG","/static/appartment1/7.JPG","/static/appartment1/8.JPG","/static/appartment1/9.jpeg","/static/appartment1/10.JPG",]'
               link="https://www.airbnb.fr/rooms/30969740?s=67&unique_share_id=f4db1ac6-a8dd-4e5d-a908-6f44eb2bc0af"
    ></Apartment>
    <Apartment title="L' Appartement 3 pièces"
               description="Appartement fraîchement rénové et décoré avec soin, en plein centre de cannes, idéalement situé entre la gare sncf et le palais des festivals, vous trouverez tout le nécessaire pour y passer un agréable séjour. Vous pourrez y dormir à 6 personnes, il dispose de deux chambres, deux salles de bain et d'un canapé lit (avec un vrai matelas système rapido). La cuisine et le salon sont séparés par un mur à verrière avec un rideau pour que les personnes dormant dans le salon aient tout l' intimité nécéssaire. Il est aussi doté d'un balcon sur rue et d'une terrasse à l' arrière."
               :files='["/static/appartment2/1.JPG","/static/appartment2/2.JPG","/static/appartment2/2.JPG","/static/appartment2/4.jpeg","/static/appartment2/5.JPG","/static/appartment2/6.JPG","/static/appartment2/7.JPG","/static/appartment2/8.JPG","/static/appartment2/9.JPG","/static/appartment2/10.JPG","/static/appartment2/11.JPG","/static/appartment2/12.JPG","/static/appartment2/13.JPG"]'
               link="https://www.airbnb.fr/rooms/27152695?s=67&unique_share_id=e46ffdd2-62fa-4c6c-bb82-65adc0bc51cb"
    ></Apartment>
  </div>
</template>

<script>
import Apartment from './Appartment'

export default {
  name: 'Home',
  components: {Apartment}
}
</script>

<style scoped>
  #Home {
    width: 50%;
    margin-left: 25%;
    margin-right: 25%;
    background-color: white;
    padding: 50px;
    -webkit-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.20);
    -moz-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.20);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.20);
  }

@media (max-width: 992px) {
  #Home {
    width: 100%;
    margin: 0;
    padding: 20px;
  }
}

p {
  text-align: center;
  font-size: 20px;
}

h2{
    text-align: center;
}

#description {
  margin-bottom: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue